import { PovService } from './pov.service';

export default angular
  .module('sfMobile.services.pov', [
    'sfMobile.services.profile',
    'sfMobile.services.api-url',
  ])
  .service('sfPOVService', PovService).name;
